import { scrollTo } from '../../../../../../utils';

export const handleScrollToPhotosClick = () => {
  const block = document.getElementById('description-and-photos');

  scrollTo(block);
};
